<template>
  <div id="pnlBarCode" :class="{ 'zoom' :$vuetify.breakpoint.mobile}" style="height:700px;">
    <table>
      <tbody>
        <tr>
          <td>
            <Barcode :rotate="90" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" @barcode="barcode" />
          </td>
          <td style="width: 300px;" />
          <td>
            <Barcode :rotate="270" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" @barcode="barcode" />
          </td>
        </tr>
        <tr>
          <td />
          <td>
            <Barcode :rotate="180" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" @barcode="barcode" />
          </td>
          <td />
        </tr>
        <tr>
          <td colspan="3">
            <div id="address">
              Buntnr:
              <h1>{{ zeroFill(bundleId,4) }}</h1>
            </div>
          </td>
        </tr>
        <tr>
          <td />
          <td>
            <Barcode :rotate="0" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" @barcode="barcode" />
          </td>
          <td />
        </tr>
        <tr>
          <td>
            <Barcode :rotate="90" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" @barcode="barcode" />
          </td>
          <td />
          <td>
            <Barcode :rotate="270" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" @barcode="barcode" />
          </td>
        </tr>
      </tbody>
    </table>    
  </div>
  
  <!-- <div>    
    <Barcode :rotate="0" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" />
    <Barcode :rotate="180" format="CODE128C" :customer-id="customerId" :bundle-id="bundleId" />    
  </div> -->
</template>

<script>
import Barcode from '@/components/web/Barcode'
export default {
  name:'EmergencyLabel',
  components:{Barcode},
   props:{     
     customerId: { type: String, required:false, default:''},
     bundleId: { type: String, required:false, default:''}         
  },
   data(){
    return{          
      nrOfInit:0
    }
  },
  mounted(){        
   if(this.nrOfInit === 6){            
        this.$emit('init', this.bundleId)        
      }
  },  
  updated(){     
    if(this.nrOfInit === 6){            
        this.$emit('init', this.bundleId)        
      }
  },
   methods:{
     barcode(){        
      this.nrOfInit +=1        
      
     },
     zeroFill( number, width )
    {
      width -= number.toString().length
      if ( width > 0 )
      {
        return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number
      }
      return number + '' // always return a string
    }
  }
  
}
</script>

<style>
#pnlBarCode {
	border: solid 3px #000;
	margin: 10px 0px 0px 0px;
	padding: 50px 0px;
	text-align: center;
	width: 600px;
  font-family: Arial, Verdana, Helvetica, Sans-Serif;
  font-size: 12px;
}

#pnlBarCode h1 {
	color: #000;
	font: 600 34px times New Roman, Arial;
	margin: 0px;
	padding: 4px 0px 0px 0px;
}

#pnlBarCode h4 {
	color: #000;
	font: 100 24px Arial;
	margin: 4px 0px 0px 0px;
	padding: 4px 0px 0px 0px;
}

#address {
	border: solid 3px #f00;
	margin: 5px 80px 5px 80px;
	padding: 10px;
	text-align: center;
}

.zoom{
  zoom:70%;
}
</style>